<template>
  <v-combobox
    v-model="selected"
    :items="labelList"
    :filter="filter"
    hide-selected
    :hide-no-data="!search || search.length < 1"
    item-value="id"
    :search-input.sync="search"
    multiple
    small-chips
    deletable-chips
    :loading="loading"
    :disabled="!canEdit"
    :label="$t('labels.tags')"
  >
    <template slot="no-data">
      <v-list-item>
        <v-list-item-content>
          <v-list-item>
            <span class="subheading">{{ $t('pressEnterToAdd') }}</span>
            <v-chip>
              {{ search }}
            </v-chip>
          </v-list-item>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isEmpty } from 'lodash/lang'
import { NAMESPACE } from '../store'

export default {
  name: 'TagsLine',
  props: {
    selection: { type: Array, default: () => [] },
    updateSelection: { type: Function, required: true },
    canEdit: { type: Boolean, default: true }
  },
  data: () => ({
    search: null,
    loading: true
  }),
  methods: {
    ...mapActions(NAMESPACE, ['listLabels']),
    filter(item, queryText, itemText) {
      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    doRemove(element) {
      this.selected = this.selected.filter((item) => item.id !== element.id)
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['labels']),
    labelList() {
      return this.search && this.search.length > 0 ? this.labels : []
    },
    selected: {
      get() {
        return this.selection
      },
      set(value) {
        this.updateSelection(value).then(() => {
          this.loading = true
          this.listLabels().then(() => {
            this.loading = false
          })
        })
      }
    }
  },
  mounted() {
    let hasData = isEmpty(this.labels)
    if (hasData) {
      this.listLabels().then(() => {
        this.loading = false
      })
    } else {
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-chip--small {
  .v-chip__close {
    .v-icon {
      font-size: 15px;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "pressEnterToAdd": "Press Enter to add"
  },
  "fr": {
    "pressEnterToAdd": "Appuyez sur Entrée pour ajouter"
  }
}
</i18n>
